import { useLanguage } from '@infl-ts/util-i18n-provider';
import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { useMutationMapper } from '@infl-ts/util-use-mutation-mapper';
import { Language as LanguageIcon } from '@mui/icons-material';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import * as A from 'fp-ts/Array';
import * as E from 'fp-ts/Either';
import { constNull, flow, pipe } from 'fp-ts/function';
import { useTranslation } from 'react-i18next';
import { SaveStates } from '../async-button';
import { useLanguages } from './queries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PureLanguageSelector = function PureLanguageSelector(_ref) {
  var data = _ref.data,
      containerSx = _ref.containerSx,
      currentLang = _ref.currentLang,
      setLang = _ref.setLang,
      t = _ref.t,
      profileMutationValue = _ref.profileMutationValue,
      reloadOnLanguageChange = _ref.reloadOnLanguageChange;
  return pipe(data, DE.refreshFold(constNull, constNull, constNull, function (_ref2) {
    var languages = _ref2.languages;
    if (A.isEmpty(languages) || languages.length === 1) return null;
    return /*#__PURE__*/_jsxs(Box, {
      sx: mergeSxProps({
        display: 'flex',
        mr: 1
      }, containerSx),
      children: [/*#__PURE__*/_jsx(LanguageIcon, {
        sx: {
          color: function color(t) {
            return t.palette.grey[800];
          },
          mr: 1,
          mt: 2,
          verticalAlign: 'middle'
        }
      }), /*#__PURE__*/_jsxs(FormControl, {
        sx: {
          width: '100%'
        },
        margin: "dense",
        children: [/*#__PURE__*/_jsx(InputLabel, {
          id: "language-selector",
          children: t('Language')
        }), /*#__PURE__*/_jsx(Select, {
          labelId: "language-selector",
          label: "Language",
          size: "small",
          value: currentLang.replace('-', '_'),
          disabled: profileMutationValue === 'saving',
          onChange: function onChange(event) {
            setLang(event.target.value, {
              reload: reloadOnLanguageChange
            });
          },
          children: languages.map(function (language) {
            return /*#__PURE__*/_jsx(MenuItem, {
              value: language.code,
              children: language.displayName
            }, language.id);
          })
        })]
      })]
    });
  }));
};

var useProps = function useProps(_ref3) {
  var reloadOnLanguageChange = _ref3.reloadOnLanguageChange,
      containerSx = _ref3.containerSx;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useLanguage = useLanguage(),
      currentLang = _useLanguage.currentLang,
      setLang = _useLanguage.setLang,
      profileMutationStatus = _useLanguage.profileMutationStatus;

  var Saving = SaveStates.Saving,
      Default = SaveStates.Default,
      Success = SaveStates.Success,
      Error = SaveStates.Error;
  var profileMutationValue = useMutationMapper(profileMutationStatus, function (_ref4) {
    var editProfile = _ref4.editProfile;
    return editProfile.__typename === 'EditProfileErrors' ? E.left(editProfile) : E.right(editProfile);
  }, [Saving, Success, Error, Default]);
  return {
    data: useLanguages(),
    currentLang: currentLang,
    t: t,
    containerSx: containerSx,
    setLang: setLang,
    profileMutationValue: profileMutationValue,
    reloadOnLanguageChange: reloadOnLanguageChange
  };
};

export var LanguageSelector = flow(useProps, PureLanguageSelector);